/* ----------------------------------------------------------------------------
 * Newsletter Quiz Popup — Klaviyo integration
 * ----------------------------------------------------------------------------
 * Overrides the two no-op hooks the popup section exposes:
 *   window.NewsletterQuizPopup.handleEmailSubmit
 *   window.NewsletterQuizPopup.handleSmsSubmit
 *
 * Reads the Klaviyo public key and list IDs from the payload itself
 * (which are set in the theme editor → Newsletter Quiz Popup → Integration).
 *
 * Uses Klaviyo's "Create Client Subscription" endpoint — public-key only,
 * safe for client-side. No private key required, no server needed.
 * Docs: https://developers.klaviyo.com/en/reference/create_client_subscription
 * --------------------------------------------------------------------------*/

(function () {
  'use strict';

  var KLAVIYO_REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

  window.NewsletterQuizPopup = window.NewsletterQuizPopup || {};

  // ------------------------------------------------------------------ helpers
  function postSubscription(companyId, body) {
    return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.ok) return { ok: true };           // 202 Accepted lives here
      return res.json().catch(function () { return {}; }).then(function (j) {
        var detail = j && j.errors && j.errors[0] && j.errors[0].detail;
        throw new Error(detail || ('Klaviyo error ' + res.status));
      });
    });
  }

  function buildProfileProperties(data) {
    // Anything you put here becomes a custom property on the Klaviyo profile,
    // which you can then use to segment flows ("send to people interested in X").
    return {
      interested_product:       data.interested_product || null,
      interested_product_label: data.interested_product_label || null,
      signup_source:            data.signup_source || null,
      popup_version:            data.popup_version || null,
      popup_variant:            data.popup_variant || null
    };
  }

  // -------------------------------------------------------------- email hook
  window.NewsletterQuizPopup.handleEmailSubmit = function (data) {
    var key    = data.integration && data.integration.klaviyo_public_key;
    var listId = data.integration && data.integration.klaviyo_list_id;

    if (!key)    return Promise.reject(new Error('Missing Klaviyo public key.'));
    if (!listId) return Promise.reject(new Error('Missing Klaviyo list ID.'));

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: data.signup_source || 'newsletter-quiz-popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email,
                properties: buildProfileProperties(data)

              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return postSubscription(key, body);
  };

  // ---------------------------------------------------------------- sms hook
  window.NewsletterQuizPopup.handleSmsSubmit = function (data) {
    var key    = data.integration && data.integration.klaviyo_public_key;
    var listId = data.integration && data.integration.klaviyo_list_id;

    if (!key)            return Promise.reject(new Error('Missing Klaviyo public key.'));
    if (!listId)         return Promise.reject(new Error('Missing Klaviyo SMS list ID.'));
    if (!data.sms_consent) return Promise.reject(new Error('SMS consent required.'));

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: data.signup_source || 'newsletter-quiz-popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email:        data.email,
                phone_number: data.phone_number,
                properties:   buildProfileProperties(data),
                subscriptions: {
                  sms: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return postSubscription(key, body);
  };
})();